const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWindow3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 4723.32 2748.45",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M4316.06,2586.28H407.25V0H4316.06V2586.28",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M4231.34,90.56V2495.71H492V90.56H4231.34",
    style: {
      fill: "#bfd1d0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M2880.47,875.11H3355c-17.68-66.05-117.17-116.59-237.28-116.59-38.24,0-74.41,5.11-106.49,14.22C2993,655.46,2916.39,567.4,2824.57,567.4c-68.16,0-128,48.55-161.73,121.55-103.58,2.43-193.58,53.7-242.42,129.09-33.6-40.09-77.65-64.39-125.9-64.39-25,0-48.89,6.55-70.81,18.44-22.76-117-117.38-204.69-230.66-204.69-90.22,0-168.6,55.65-208.28,137.39a143.22,143.22,0,0,0-65.14-15.92c-33.51,0-65,12-92.27,33.13-42.24-111.65-122.25-187-214-187-60.94,0-116.68,33.22-159.64,88.22a361.35,361.35,0,0,0-72.27-7.24c-169.15,0-306.27,116-306.27,259.11h2005.3",
    style: {
      fill: "#e2e8ec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M4231.34,1663.35H3583.22v348H3080.5v-257.9h-480V1262.34H2279.88l-94.1,102.18H2083v571.92l-363.36-6.54V1255.78l-617.83,6.56v266.4h-614l.68,969.48H4231.34V1663.35",
    style: {
      fill: "#c3d8dd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M1101.84,1528.75h-101l101-140.64v140.64m91-267.38,277.26-386.25h16.65v383.14l-293.91,3.11",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M1486.71,875.12h-16.65l16.65-23.22v23.22",
    style: {
      fill: "#f7f7f7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M1170.57,2495.71H492v-7.6L517.65,2202l483.24-673.25h101V1388.09l91-126.74,293.93-3.11v797l-316.16,440.44",
    style: {
      fill: "#cfe0e4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M1719.65,1730.76v-475l-159.59,1.69V875.13h773.79l-614.2,855.63M2393.87,791.5c-28.94-24-62.95-37.85-99.35-37.85-25,0-48.92,6.56-70.81,18.45-22.77-117-117.41-204.67-230.68-204.67-90.21,0-168.61,55.63-208.28,137.35a143.09,143.09,0,0,0-65.14-15.89c-33.52,0-65,12-92.25,33.13a421.86,421.86,0,0,0-18-41L2033.21,90.58H2897L2393.87,791.5",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M2333.86,875.1h-773.8V749.73l49.3-68.68a417,417,0,0,1,18,41c27.28-21.09,58.74-33.13,92.26-33.13a143.17,143.17,0,0,1,65.13,15.91C1824.44,623,1902.84,567.4,1993.05,567.4c113.29,0,207.91,87.72,230.67,204.68,21.9-11.89,45.8-18.44,70.81-18.44,36.41,0,70.42,13.84,99.34,37.84l-60,83.62",
    style: {
      fill: "#f7f7f7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M1560.06,1953.1V1257.47l159.6-1.68v475l-159.6,222.35",
    style: {
      fill: "#cfe0e4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M4016,535c0,140.48-113.89,254.36-254.36,254.36S3507.28,675.51,3507.28,535s113.86-254.35,254.35-254.35S4016,394.57,4016,535",
    style: {
      fill: "#fcea9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M2083,1936.45l-232.13-4.19L2083,1608.88v327.57m517.42-446.68V1262.34H2331.8l278-387.24h431.88l-441.2,614.67m410.82-717c-17.84-114.74-91.58-201.49-180.75-205.2l342.38-477h8.88V679.87l-56.5,78.7c-2.49-.06-5-.06-7.53-.06-38.24,0-74.39,5.12-106.48,14.23",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M3041.62,875.13H2609.74L2830.5,567.55c89.15,3.72,162.91,90.46,180.74,205.21,32.1-9.12,68.25-14.24,106.49-14.24q3.78,0,7.54.07l-83.65,116.54",
    style: {
      fill: "#f7f7f7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M1878.34,2495.72H1560.05V2337.45l290.85-405.18,232.12,4.18V1608.89l248.76-346.54h268.65v227.42L1878.34,2495.72m-391.62,0h-40.26l40.26-56.08v56.08",
    style: {
      fill: "#cfe0e4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M3255.12,577.7V90.57h349.67L3255.12,577.7",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M3583.22,2011.35H3255.13V1387.6l436.42-608a254.49,254.49,0,0,0,70.09,9.77C3902.11,789.39,4016,675.51,4016,535a253.22,253.22,0,0,0-45.07-144.61L4186.17,90.56h45.17V1231L3921,1663.35H3583.22v348",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M3323.52,2495.71h-68.39V2011.35h328.1v-348H3921l-597.47,832.36",
    style: {
      fill: "#cfe0e4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M3181.77,2011.35H3080.48V1753.46h-88l189.26-263.67v521.56",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M3181.77,2495.71h-722l532.78-742.25h88v257.89h101.29v484.36",
    style: {
      fill: "#cfe0e4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M3761.63,789.39a254.6,254.6,0,0,1-70.09-9.77l279.37-389.19A253.27,253.27,0,0,1,4016,535c0,140.48-113.89,254.36-254.36,254.36",
    style: {
      fill: "#fdeeb1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M3255.12,2564.43h-73.35V21.84h73.35V2564.43",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M1560.05,2545.72H1486.7V40.58h73.35V2545.72",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "M4723.32,2748.45H0V2586.27H4723.32v162.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M4316.06,2586.28H407.25v-1.74h76.11l3.48-38.83H3181.76v18.72h73.35v-18.72h1061v40.57",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M3255.12,2564.43h-73.35v-18.72h73.35v18.72",
    style: {
      fill: "#ebebeb"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWindow3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/window3.e24d78fdccdacabf6ac1caae7bfce13a.svg";